(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soma-full-width-media"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('soma-fwm-video')) {
    class SomaFwmVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;

        const breakpoint = this.dataset.breakpoint;
        if (breakpoint === 'mobile') this.query = window.matchMedia('(max-width: 749px)');
        if (breakpoint === 'desktop') this.query = window.matchMedia('(min-width: 750px)');

        this.onChange = () => this.update();
        this.query?.addEventListener('change', this.onChange);
        this.update();
      }

      disconnectedCallback() {
        this.query?.removeEventListener('change', this.onChange);
        this.stopObserving();
      }

      update() {
        const active = !this.query || this.query.matches;

        if (!active) {
          this.stopObserving();
          if (this.loaded) this.video.pause();
          return;
        }

        if (!this.video.poster && this.video.dataset.poster) {
          this.video.poster = this.video.dataset.poster;
        }

        if (this.loaded) {
          this.play();
          return;
        }

        if ('lazy' in this.dataset && 'IntersectionObserver' in window) {
          if (this.observer) return;
          this.observer = new IntersectionObserver(
            (entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;
              this.stopObserving();
              this.load();
            },
            { rootMargin: '200px 0px' }
          );
          this.observer.observe(this);
          return;
        }

        this.load();
      }

      stopObserving() {
        this.observer?.disconnect();
        this.observer = null;
      }

      load() {
        this.querySelectorAll('source[data-src]').forEach((source) => {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
        });
        this.video.preload = 'metadata';
        this.video.load();
        this.loaded = true;
        this.play();
      }

      play() {
        if (!('autoplay' in this.dataset)) return;
        this.video.play().catch(() => {});
      }
    }

    customElements.define('soma-fwm-video', SomaFwmVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soma-jotform"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('soma-jotform')) {
    const HANDLER_SRC = 'https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js';
    let handlerPromise = null;

    const loadHandler = () => {
      if (window.jotformEmbedHandler) return Promise.resolve();
      if (handlerPromise) return handlerPromise;

      handlerPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = HANDLER_SRC;
        script.async = true;
        script.onload = resolve;
        script.onerror = () => {
          handlerPromise = null;
          reject();
        };
        document.head.appendChild(script);
      });

      return handlerPromise;
    };

    class SomaJotform extends HTMLElement {
      connectedCallback() {
        if (this.loaded) return;

        this.formId = this.dataset.formId || '';
        if (!/^\d+$/.test(this.formId)) return;

        if (!('IntersectionObserver' in window)) {
          this.load();
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.stopObserving();
            this.load();
          },
          { rootMargin: '600px 0px' }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.stopObserving();
      }

      stopObserving() {
        this.observer?.disconnect();
        this.observer = null;
      }

      load() {
        this.loaded = true;

        const iframe = document.createElement('iframe');
        iframe.id = `JotFormIFrame-${this.formId}`;
        iframe.title = 'Form';
        const prefillId = this.dataset.prefillId || '';
        iframe.src = /^[0-9a-f]+$/.test(prefillId)
          ? `https://form.jotform.com/${this.formId}/prefill/${prefillId}`
          : `https://form.jotform.com/${this.formId}`;
        iframe.allow = 'geolocation; microphone; camera; fullscreen';
        iframe.setAttribute('allowtransparency', 'true');
        iframe.setAttribute('scrolling', 'no');
        iframe.setAttribute('frameborder', '0');
        this.appendChild(iframe);
        this.setAttribute('data-loaded', '');

        loadHandler()
          .then(() => {
            window.jotformEmbedHandler(`iframe[id='JotFormIFrame-${this.formId}']`, 'https://form.jotform.com/');
          })
          .catch(() => {});
      }
    }

    customElements.define('soma-jotform', SomaJotform);
  }

  } catch(e) { console.error(e); }
})();
})();
